import React from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

import Header from "../Header/Header";
import MainPage from "../MainPage/MainPage";
import Collections from "../Collections/Collections";
import About from "../About/About";
import AdvancedSearch from "Containers/AdvancedSearch/AdvancedSearch";
import AdvancedSearchPopc1 from "Containers/AdvancedSearchPopc1/AdvancedSearchPopc1";
import GalleryPage from "Containers/GalleryPage/GalleryPage";
import Archives from "../Archives/Archives";
import ArchiveList from "../ArchiveList/ArchiveList";
import CollectionList from "../CollectionList/CollectionList";
import ArchiveShow from "../ArchiveShow/ArchiveShow";
import ErrorSite from "../ErrorSite/errorSite";
import AvailabilityDeclaration from "../AvailabilityDeclaration/availabilityDeclaration";
import PrivacyPolicy from "../PrivacyPolicy/privacyPolicy";
import Chopiniana from "Containers/Chopiniana/Chopiniana";
import Articles from "Containers/Articles/Articles";
import ArticleShow from "Containers/ArticleShow/ArticleShow";
import AdvertisementSquare from "Containers/Advertisement1/AdvertisementSquare";
import AdvertisementRectangle from "Containers/Advertisement2/AdvertisementRectangle";

const App = () => {

    const lang = window.location.href.split('/')[3]

    return (
      <>
        <Switch>
          <Route exact path={"/:lang(pl|en)"}>
            <Header />
            <MainPage />
          </Route>

          <Route exact path={"/:lang(pl|en)/lokalizacje"}>
            <Header />
            <Archives />
          </Route>

          <Route exact path={"/:lang(pl|en)/:destination(lokalizacje)/:id"}>
            <Header />
            <ArchiveList />
          </Route>

          <Route exact path={"/:lang(pl|en)/lokalizacje/:id/szczegoly"}>
            <Header />
            <ArchiveShow />
          </Route>

          <Route exact path={"/:lang(pl|en)/:destination(lokalizacje)/:id/:params(sortuj)"}>
            <Header />
            <ArchiveList />
          </Route>

          <Route exact path={"/:lang(pl|en)/:destination(kolekcje|lokalizacje)/galeria/:type/:id"}>
            <GalleryPage />
          </Route>

          <Route
            exact
            path={
              "/:lang(pl|en)/:destination(kolekcje|lokalizacje)/galeria/:type(rekopisy|druki-muzyczne|klocki-introligatorskie)/:id/:page(\\d+)"
            }
          >
            <GalleryPage />
          </Route>

          <Route
            exact
            path={
              "/:lang(pl|en)/:destination(kolekcje|lokalizacje)/galeria/:type(rekopisy|druki-muzyczne|klocki-introligatorskie)/:id/:page(\\d+)/:children(\\d+)"
            }
          >
            <GalleryPage />
          </Route>

          <Route exact path={"/:lang(pl|en)/kolekcje"}>
            <Header />
            <Collections />
          </Route>

          <Route exact path={"/:lang(pl|en)/:destination(kolekcje)/:id"}>
            <Header />
            <CollectionList />
          </Route>

          <Route exact path={"/:lang(pl|en)/o-projekcie"}>
            <Header />
            <About />
          </Route>

          <Route exact path={"/:lang(pl|en)/artykuly"}>
            <Header />
            <Articles />
          </Route>

          <Route exact path={"/:lang(pl|en)/artykuly/:id/szczegoly"}>
            <Header />
            <ArticleShow />
          </Route>

          {/* <Route exact path={"/:lang(pl|en)/chopiniana"}>
                    <Header />
                    <Chopiniana />
                </Route> */}

          <Route exact path={"/:lang(pl|en)/szukaj/:params"}>
            <Header />
            <AdvancedSearch />
          </Route>

          <Route exact path={"/:lang(pl|en)/szukajpopc1/:params"}>
            <Header />
            <AdvancedSearchPopc1 />
          </Route>

          <Route exact path={"/:lang(pl|en)/deklaracja-dostepnosci"}>
            <Header />
            <AvailabilityDeclaration />
          </Route>

          <Route exact path={"/:lang(pl|en)/polityka-prywatnosci"}>
            <Header />
            <PrivacyPolicy />
          </Route>

          <Route exact path={"/:lang(pl|en)/ad-1"}>
            <AdvertisementSquare />
          </Route>

          <Route exact path={"/:lang(pl|en)/ad-2"}>
            <AdvertisementRectangle />
          </Route>

          <Route exact path={"/"}>
            <Redirect to="/pl" />
          </Route>

          <Route path={"/:lang(pl|en)/*"}>
            <Header />
            <ErrorSite />
          </Route>

          <Route path={"*"}>
            <Header />
            <ErrorSite />
          </Route>

          {/* <Route path={"*"}>
            {lang === "pl" || lang === "en" ? (
              <Redirect to={`/${lang}/error`} />
            ) : (
              <Redirect to={"/pl"} />
            )}
          </Route> */}
        </Switch>
      </>
    );
};

function Builder() {
    return (
        <Router>
            <App />
        </Router>
    );
}

export default Builder;
